var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0917969,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F15C61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.9132L19.5355 11.3776L20.714 12.5561L17.1785 16.0917L20.714 19.6272L19.5355 20.8057L16 17.2702L12.4645 20.8057L11.286 19.6272L14.8215 16.0917L11.286 12.5561L12.4645 11.3776L16 14.9132Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.6ac5417a83ab8997e2064376f3b814c2.svg";
export { ForwardRef as ReactComponent };